export function getIndianStates() {
    const indianStates = [
        { key: "Andaman and Nicobar Islands", label: "Andaman and Nicobar Islands" },
        { key: "Andhra Pradesh", label: "Andhra Pradesh" },
        { key: "Arunachal Pradesh", label: "Arunachal Pradesh" },
        { key: "Assam", label: "Assam" },
        { key: "Bihar", label: "Bihar" },
        { key: "Chandigarh", label: "Chandigarh" },
        { key: "Chhattisgarh", label: "Chhattisgarh" },
        { key: "Dadra and Nagar Haveli", label: "Dadra and Nagar Haveli" },
        { key: "Daman and Diu", label: "Daman and Diu" },
        { key: "Delhi", label: "Delhi" },
        { key: "Goa", label: "Goa" },
        { key: "Gujarat", label: "Gujarat" },
        { key: "Haryana", label: "Haryana" },
        { key: "Himachal Pradesh", label: "Himachal Pradesh" },
        { key: "Jammu and Kashmir", label: "Jammu and Kashmir" },
        { key: "Jharkhand", label: "Jharkhand" },
        { key: "Karnataka", label: "Karnataka" },
        { key: "Kerala", label: "Kerala" },
        { key: "Lakshadweep", label: "Lakshadweep" },
        { key: "Madhya Pradesh", label: "Madhya Pradesh" },
        { key: "Maharashtra", label: "Maharashtra" },
        { key: "Manipur", label: "Manipur" },
        { key: "Meghalaya", label: "Meghalaya" },
        { key: "Mizoram", label: "Mizoram" },
        { key: "Nagaland", label: "Nagaland" },
        { key: "Odisha", label: "Odisha" },
        { key: "Puducherry", label: "Puducherry" },
        { key: "Punjab", label: "Punjab" },
        { key: "Rajasthan", label: "Rajasthan" },
        { key: "Sikkim", label: "Sikkim" },
        { key: "Tamil Nadu", label: "Tamil Nadu" },
        { key: "Telangana", label: "Telangana" },
        { key: "Tripura", label: "Tripura" },
        { key: "Uttarakhand", label: "Uttarakhand" },
        { key: "Uttar Pradesh", label: "Uttar Pradesh" },
        { key: "West Bengal", label: "West Bengal" }
    ];

    return {
        indianStates
    };
}
